import React from 'react';
import { CheckIcon, DownloadIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Cta } from './Cta';
import { CountdownInline } from './CountdownInline';
import { itemsValor, valorTotal } from '../data/bonos';
import { plan } from '../data/planes';
const sellos: Array<{
  icono: React.ComponentType<{
    className?: string;
  }>;
  texto: string;
}> = [{
  icono: LockIcon,
  texto: 'Pago 100% seguro'
}, {
  icono: ZapIcon,
  texto: 'Acceso en 5 minutos'
}, {
  icono: DownloadIcon,
  texto: 'PDF descargable'
}, {
  icono: ShieldCheckIcon,
  texto: 'Garantía 7 días'
}];
export function ValueStack() {
  return <section id="checkout" aria-labelledby="valor-titulo" className="w-full scroll-mt-6 bg-surface px-6 py-20" data-id="element-244" data-mp="2965wnw1lvp8a">
      <div className="mx-auto max-w-2xl" data-id="element-245" data-mp="2d6pr2rusoeqq">
        <h2 id="valor-titulo" className="text-center font-display text-3xl font-bold text-ink sm:text-4xl" data-id="element-246" data-mp="30xv5d2l36yyx">
          Todo lo que recibís hoy
        </h2>

        <div className="mt-10 overflow-hidden rounded-3xl border-2 border-brand-500 bg-canvas shadow-lift" data-id="element-247" data-mp="35r7v5g1i5bt9">
          <div className="flex flex-wrap items-center justify-between gap-3 bg-brand-500 px-6 py-3" data-id="element-248" data-mp="1td0fmna8b7k6">
            <p className="text-xs font-bold uppercase tracking-[0.14em] text-ink" data-id="element-249" data-mp="1oefg6q2swrws">
              🔥 Oferta de lanzamiento
            </p>
            <p className="text-xs font-bold text-ink" data-id="element-250" data-mp="1ye694nbpqyur">
              Cierra en <CountdownInline data-id="element-251" data-mp="2c5umsv1m1vdu" />
            </p>
          </div>

          <ul className="divide-y divide-edge bg-surface" data-id="element-252" data-mp="2c49ulc2rqoj5">
            {itemsValor.map(item => <li key={item.nombre} className="flex items-center justify-between gap-4 px-6 py-3" data-id="element-253" data-mp="283zm9sri7m14">
                <span className="flex items-start gap-2.5 text-sm text-body" data-id="element-254" data-mp="2m3922rbsse4k">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-600" aria-hidden="true" data-id="element-255" data-mp="2h68x6jqophf1" />
                  {item.nombre}
                </span>
                <span className="shrink-0 text-sm font-semibold text-muted line-through" data-id="element-256" data-mp="mqwlzanmiec8">{item.precio}</span>
              </li>)}
          </ul>

          <div className="border-t border-edge px-6 py-6 text-center" data-id="element-257" data-mp="2muqqinwvhzt1">
            <p className="text-sm text-muted" data-id="element-258" data-mp="2rrh6lb8ogveg">
              Valor total del sistema <span className="line-through" data-id="element-259" data-mp="2vu3zlfh34md8">{valorTotal}</span>
            </p>

            <p className="mt-4 text-xs font-bold uppercase tracking-[0.16em] text-brand-700" data-id="element-260" data-mp="2vw70wvnou1x9">
              Tu inversión hoy
            </p>
            <p className="mt-1 flex items-center justify-center gap-3 font-display text-6xl font-bold leading-none text-brand-700" data-id="element-261" data-mp="35sti9agt2auj">
              <span aria-hidden="true" data-id="element-262" data-mp="3apjvlq186sc9">🔥</span>
              <span className="whitespace-nowrap" data-id="element-263" data-mp="3fi3dv0auybne">{plan.precioHoy}</span>
            </p>
            <p className="mt-3 inline-flex rounded-full bg-brand-100 px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-brand-800" data-id="element-264" data-mp="3jjf2p3lwqsuj">
              Ahorrás $120 USD · 88% de descuento
            </p>

            <div className="mx-auto mt-6 max-w-md rounded-2xl border border-naranja/40 bg-naranja/10 px-5 py-4" data-id="element-265" data-mp="3thcqxr3ropn5">
              <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-naranja" data-id="element-266" data-mp="7gf5rib45pyi">
                Este precio vence en
              </p>
              <p className="mt-1 text-xl font-bold sm:text-2xl" data-id="element-267" data-mp="2fr6yagn84tq">
                <CountdownInline data-id="element-268" data-mp="3toepkini1dxl" />
              </p>
            </div>

            <div id="boton-compra" className="mt-7 scroll-mt-24" data-id="element-269" data-mp="3pm1lrzsbbq3g">
              <Cta externo className="animate-atencion" data-id="element-270" data-mp="3pnuvxp24wsg7">
                {plan.cta} →
              </Cta>
            </div>
            <p className="mt-3 text-xs text-muted" data-id="element-271" data-mp="l7k1487g7w31">
              Pago único · Sin suscripción · Acceso de por vida · Conversión automática a tu moneda local
            </p>

            <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 border-t border-edge pt-5" data-id="element-272" data-mp="geqqx4t7nvjk">
              {sellos.map(sello => <li key={sello.texto} className="flex items-center gap-1.5 text-xs font-medium text-muted" data-id="element-273" data-mp="18y63biurum54">
                  <sello.icono className="h-3.5 w-3.5 text-brand-600" aria-hidden="true" data-id="element-274" data-mp="145mic0tr8oqa" />
                  {sello.texto}
                </li>)}
            </ul>
            <p className="mt-4 text-xs text-muted" data-id="element-275" data-mp="tnrcmomvubuf">
              💳 Tarjeta de crédito y débito · 🏦 Transferencia · 📱 Plataformas de pago locales
            </p>
          </div>
        </div>
      </div>
    </section>;
}